import { useState, useEffect } from "react";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";

export interface SystemConfig {
  orderDelayThreshold: number; // minutes
  deliveryDelayThreshold: number; // minutes
}

const DEFAULT_CONFIG: SystemConfig = {
  orderDelayThreshold: 10,
  deliveryDelayThreshold: 30,
};

export const useConfig = (restaurantId: string | undefined) => {
  const [config, setConfig] = useState<SystemConfig>(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!restaurantId) {
      setLoading(false);
      return;
    }

    const docRef = doc(db, "restaurants", restaurantId, "config", "general");
    const unsubscribe = onSnapshot(docRef, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setConfig({
          orderDelayThreshold: data.orderDelayThreshold ?? DEFAULT_CONFIG.orderDelayThreshold,
          deliveryDelayThreshold: data.deliveryDelayThreshold ?? DEFAULT_CONFIG.deliveryDelayThreshold,
        });
      } else {
        // If config doesn't exist, we just keep default values
        setConfig(DEFAULT_CONFIG);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [restaurantId]);

  const updateConfig = async (newConfig: Partial<SystemConfig>) => {
    if (!restaurantId) return;
    const docRef = doc(db, "restaurants", restaurantId, "config", "general");
    await setDoc(docRef, newConfig, { merge: true });
  };

  return { config, loading, updateConfig };
};
